export function saveAs(data: Blob, fileName: string): void {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(data);
  a.setAttribute('download', fileName);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
